import React from 'react'

export default function AccountSuspended() {
  return (
    <div className='page'>
        <h1>Your Account has been suspended by the Admin. Please contact Admin to recover your account.</h1>
    </div>
  )
}
